import { render, staticRenderFns } from "./lxfs.vue?vue&type=template&id=084d2808&scoped=true"
import script from "./lxfs.vue?vue&type=script&lang=js"
export * from "./lxfs.vue?vue&type=script&lang=js"
import style0 from "./lxfs.vue?vue&type=style&index=0&id=084d2808&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d2808",
  null
  
)

export default component.exports